import api from '../utils/api'
import {
  BOOK_TIME_SUCCESS,
  BOOK_TIME_ERROR,
  CANCEL_BOOKED_LESSON_SUCCESS,
  CANCEL_BOOKED_LESSON_ERROR,
  GET_ALL_BOOKED_LESSONS_SUCCESS,
  GET_ALL_BOOKED_LESSONS_ERROR,
  GET_BOOKED_LESSON_SUCCESS,
  GET_BOOKED_LESSON_ERROR,
  GET_BOOKED_LESSONS_OF_A_TEACHER_SUCCESS,
  GET_BOOKED_LESSONS_OF_A_TEACHER_ERROR,
  SYNC_ORDER_SUCCESS,
  SYNC_ORDER_ERROR,
  CONFIRM_ORDER_SUCCEEDED_SUCCESS,
  CONFIRM_ORDER_SUCCEEDED_FAIL,
  DELETE_BOOKED_LESSON_BY_ADMIN_SUCCESS,
  DELETE_BOOKED_LESSON_BY_ADMIN_ERROR,
  UPDATE_PAID_FOR_TEACHER_STATUS_SUCCESS,
  UPDATE_PAID_FOR_TEACHER_STATUS_ERROR,
  CREATE_COMPLAINT_SUCCESS,
  CREATE_COMPLAINT_ERROR
} from './types'
import { toast } from 'react-toastify'
import { getProfileTeacherById } from './profileTeacher'
import { getProfileStudentById } from './profileStudent'

// Book time for learning
export const bookTime = (bookedTime) => async (dispatch) => {
  try {
    const res = await api.post('/learning-schedule-for-student', bookedTime)

    dispatch({
      type: BOOK_TIME_SUCCESS,
      payload: res.data,
    })

    toast.success('Bạn đã đặt lịch học thành công!')
  } catch (err) {
    const errors = err.response.data.errors

    if (errors) {
      errors.forEach((error) => {
        toast.error(error.msg)
      })
    }

    dispatch({
      type: BOOK_TIME_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

export const confirmOrderSucceeded = (orderId) => async (dispatch) => {
  try {
    const res = await api.put(
      `/learning-schedule-for-student/${orderId}/successful-booked-lesson-confirmation`
    )

    const data = res.data.bookedLesson

    dispatch({
      type: CONFIRM_ORDER_SUCCEEDED_SUCCESS,
      payload: data,
    })
  } catch (err) {
    dispatch({
      type: CONFIRM_ORDER_SUCCEEDED_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Cancel a booked lesson by student
export const cancelBookedLessonByStudent = (bookedLessonId) => async (dispatch) => {
  try {
    const res = await api.delete(
      `/learning-schedule-for-student/cancel-booked-lesson-by-student/${bookedLessonId}`
    )

    dispatch({
      type: CANCEL_BOOKED_LESSON_SUCCESS,
      payload: {
        bookedLessonId,
        newTeacherAvailableTime: res.data.newTeacherAvailableTime,
      },
    })

    toast.info(res.data.msg)
  } catch (err) {
    dispatch({
      type: CANCEL_BOOKED_LESSON_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Cancel a booked lesson by teacher
export const cancelBookedLessonByTeacher = (bookedLessonId) => async (dispatch) => {
  try {
    const res = await api.delete(
      `/learning-schedule-for-student/cancel-booked-lesson-by-teacher/${bookedLessonId}`
    )

    dispatch({
      type: CANCEL_BOOKED_LESSON_SUCCESS,
      payload: {
        bookedLessonId,
        newTeacherAvailableTime: res.data.newTeacherAvailableTime,
      },
    })

    toast.info(res.data.msg)
  } catch (err) {
    dispatch({
      type: CANCEL_BOOKED_LESSON_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Get all booked lessons
export const getBookedLessons = (userId) => async (dispatch) => {
  try {
    const res = await api.get(`/learning-schedule-for-student/bookedLessons/users/${userId}`)

    dispatch({
      type: GET_ALL_BOOKED_LESSONS_SUCCESS,
      payload: res.data,
    })
  } catch (err) {
    dispatch({
      type: GET_ALL_BOOKED_LESSONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Get booked lesson by id
export const getBookedLessonById = (bookedLessonId) => async (dispatch) => {
  try {
    const res = await api.get(
      `/learning-schedule-for-student/${bookedLessonId}`
    )

    dispatch({
      type: GET_BOOKED_LESSON_SUCCESS,
      payload: res.data,
    })

    return res.data
  } catch (err) {
    dispatch({
      type: GET_BOOKED_LESSON_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Get all bookded lessons of a teacher
export const getBookedLessonsOfATeacher = (teacherId) => async (dispatch) => {
  try {
    const res = await api.get(`/teachers/${teacherId}/bookedLessons`)

    dispatch({
      type: GET_BOOKED_LESSONS_OF_A_TEACHER_SUCCESS,
      payload: res.data,
    })
  } catch (err) {
    dispatch({
      type: GET_BOOKED_LESSONS_OF_A_TEACHER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

export const getBookedLessonAndProfileTeacher =
  (bookedLessonId) => async (dispatch) => {
    dispatch(getBookedLessonById(bookedLessonId)).then((res) =>
      dispatch(getProfileTeacherById(res.teacher))
    )
  }

export const getBookedLessonAndProfileStudent =
  (bookedLessonId) => async (dispatch) => {
    dispatch(getBookedLessonById(bookedLessonId)).then((res) =>
      dispatch(getProfileStudentById(res.user._id))
    )
  }

export const syncSuccessfulOrder = (app_trans_id) => async (dispatch) => {
  try {
    const res = await api.get(
      `/zaloPayment/sync-successful-order/${app_trans_id}`
    )

    dispatch({
      type: SYNC_ORDER_SUCCESS,
      payload: res.data,
    })

    return res.data
  } catch (err) {
    dispatch({
      type: SYNC_ORDER_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

export const syncSuccessfulOrderAndGetTeacherProfileById =
  (app_trans_id) => async (dispatch) => {
    dispatch(syncSuccessfulOrder(app_trans_id)).then((res) => {
      dispatch(getProfileTeacherById(res.bookedLesson.teacher._id))
    })
  }

// Get all booked lessons for admin
export const getBookedLessonsForAdmin = () => async (dispatch) => {
  try {
    const res = await api.get('/learning-schedule-for-student/admin')

    dispatch({
      type: GET_ALL_BOOKED_LESSONS_SUCCESS,
      payload: res.data.bookedLessons,
    })
  } catch (err) {
    dispatch({
      type: GET_ALL_BOOKED_LESSONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Delete a booked lesson by admin
export const deleteBookedLessonByAdmin = (bookedLessonId) => async (dispatch) => {
  try {
    await api.delete(`/learning-schedule-for-student/${bookedLessonId}/admin`)

    dispatch({
      type: DELETE_BOOKED_LESSON_BY_ADMIN_SUCCESS,
      payload: bookedLessonId
    })
  } catch (err) {
    dispatch({
      type: DELETE_BOOKED_LESSON_BY_ADMIN_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Update paid for teacher status
export const updatePaidForTeacherStatus = (bookedLessonId) => async (dispatch) => {
  try {
    const res = await api.put(`/learning-schedule-for-student/${bookedLessonId}/paid-for-teacher-status`)

    dispatch({
      type: UPDATE_PAID_FOR_TEACHER_STATUS_SUCCESS,
      payload: res.data.updatedBookedLesson
    })
  } catch (err) {
    dispatch({
      type: UPDATE_PAID_FOR_TEACHER_STATUS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Get booked lesson by app trans id
export const getBookedLessonByAppTransId = (appTransId) => async (dispatch) => {
  try {
    const res = await api.get(
      `/learning-schedule-for-student/${appTransId}/app_trans_id`
    )

    dispatch({
      type: GET_BOOKED_LESSON_SUCCESS,
      payload: res.data.bookedLesson,
    })

    return res.data
  } catch (err) {
    dispatch({
      type: GET_BOOKED_LESSON_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

// Cancel a booked lesson by teacher
export const cancelBookedLessonByTeacherV2 = (bookedLessonId) => async (dispatch) => {
  try {
    const res = await api.delete(`/learning-schedule-for-student/${bookedLessonId}/booked-lesson-cancellation-by-teacher`)

    dispatch({
      type: CANCEL_BOOKED_LESSON_SUCCESS,
      payload: res.data.bookedLesson
    })

    toast.success('Deleted booked lesson successfully')

  } catch (err) {
    dispatch({
      type: CANCEL_BOOKED_LESSON_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}

export const createAComplaint = (complaint) => async (dispatch) => {
  try {
    const res = await api.post(`/learning-schedule-for-student/${complaint.bookedLessonId}/complaint`, { content: complaint.content, isRequestedRefund: complaint.isRequestedRefund })

    dispatch({
      type: CREATE_COMPLAINT_SUCCESS,
      payload: res.data.data
    })

    toast.success('Bạn đã gửi khiếu nại thành công')

  } catch (err) {
    dispatch({
      type: CREATE_COMPLAINT_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })

    toast.error('Rất tiếc, đa xảy ra lỗi, vui lòng thử lại sau')
  }
}

// Get booked lesson by app trans id
export const getBookedLessonByMoMoOrderId = (MoMoOrderId) => async (dispatch) => {
  try {
    const res = await api.get(
      `/learning-schedule-for-student/${MoMoOrderId}/momo_order_id`
    )

    dispatch({
      type: GET_BOOKED_LESSON_SUCCESS,
      payload: res.data.bookedLesson,
    })

    return res.data
  } catch (err) {
    dispatch({
      type: GET_BOOKED_LESSON_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}